// removed by extract-text-webpack-plugin
module.exports = {"cancelLink":"cancelLink__2bfPV","cancelButton":"cancelButton__14R_K","cancelButtonContainer":"cancelButtonContainer__EzH64"};


//////////////////
// WEBPACK FOOTER
// ./components/cancelTransactionButton/style.css
// module id = zed/
// module chunks = 308 319 320 327 328 335 338 352